import React from 'react';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { PageLayout } from '@/components/PageLayout';
import { AppSidebar } from '@/components/layout/AppSidebar';
import { AppTopBar } from '@/components/layout/AppTopBar';
import { OtherTabTeamBanner } from '@/components/layout/OtherTabTeamBanner';
import { SessionRefreshBanner } from '@/components/layout/SessionUnreachable';
import { PageTopBarProvider } from '@/components/layout/PageTopBarContext';
import { ProductContentQueueBootstrap } from '@/components/layout/ProductContentQueueBootstrap';
import { TaskLiveConnector } from '@/components/tasks/TaskLiveConnector';
import { TasksPanelHost } from '@/components/tasks/TasksPanel';
import { TaskSavingIndicator } from '@/components/tasks/TaskSavingIndicator';
import { UnsavedChangesNavigator } from '@/hooks/useUnsavedChangesGuard';
import { useActivityTracking } from '@/hooks/use-activity-tracking';

/**
 * Shell for team-required application routes. Includes searchable sidebar
 * and the sticky top bar with breadcrumbs and store switcher. Counts the tab's active minutes (T-77).
 */
export function TeamLayout({ children }: { children: React.ReactNode }) {
  // Time tracking (T-77): this tab's active minutes.
  useActivityTracking();
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <PageTopBarProvider>
          <UnsavedChangesNavigator />
          <ProductContentQueueBootstrap />
          <TaskLiveConnector />
          <AppTopBar />
          <PageLayout
            banner={
              <>
                <SessionRefreshBanner />
                <OtherTabTeamBanner />
              </>
            }
          >
            {children}
          </PageLayout>
          <TasksPanelHost />
          <TaskSavingIndicator />
        </PageTopBarProvider>
      </SidebarInset>
    </SidebarProvider>
  );
}
